<div *ngIf="isLoading" id="pause" class="d-flex align-items-center justify-content-center">
    <nx-spinner nxSize="large" id="spinner"></nx-spinner>
</div>